/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { GetInspectionTemplateQueryResponse, GetInspectionTemplatePathParams, GetInspectionTemplate400, GetInspectionTemplate401, GetInspectionTemplate403, GetInspectionTemplate404, GetInspectionTemplate409, GetInspectionTemplate500 } from "../../types/equipmentController/GetInspectionTemplate.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getGetInspectionTemplateUrl(organizationId: GetInspectionTemplatePathParams["organizationId"], equipmentId: GetInspectionTemplatePathParams["equipmentId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/equipment/${equipmentId}/inspection-template` as const }
  return res
}

/**
 * @summary Get inspection checklist template
 * {@link /api/organizations/:organizationId/equipment/:equipmentId/inspection-template}
 */
export async function getInspectionTemplate(organizationId: GetInspectionTemplatePathParams["organizationId"], equipmentId: GetInspectionTemplatePathParams["equipmentId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetInspectionTemplateQueryResponse, ResponseErrorConfig<GetInspectionTemplate400 | GetInspectionTemplate401 | GetInspectionTemplate403 | GetInspectionTemplate404 | GetInspectionTemplate409 | GetInspectionTemplate500>, unknown>({ method : "GET", url : getGetInspectionTemplateUrl(organizationId, equipmentId).url.toString(), ... requestConfig })
  return res.data
}